import { StatusCell } from '@/list/components/cells/status-cell';
import * as userSelectors from '@/user/user-selectors';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import * as lc from './license-content-styles';

export function LicenseStatusDropdown(props) {
  const {
    ariaLabel,
    disabled: forceDisabled,
    loading,
    selected,
    setSelected,
    options = [],
  } = props;

  const userRights = useSelector(userSelectors.userRights);

  const disabled =
    !userRights.editLicense || !options.length || loading || forceDisabled;

  const onSelect = useCallback(
    (option) => {
      if (!disabled) setSelected(option);
    },
    [disabled, setSelected]
  );

  return (
    <lc.StatusGroupDropdown
      aria-label={ariaLabel}
      disabled={disabled}
      loading={loading}
      title={selected}
    >
      {options.map((option) => (
        <lc.StatusGroupDropdown.Item
          key={option}
          onSelect={() => onSelect(option)}
        >
          <StatusCell value={option} />
        </lc.StatusGroupDropdown.Item>
      ))}
    </lc.StatusGroupDropdown>
  );
}
